import React, { useMemo } from 'react'

import { Text } from 'system'

const getColors = colorScheme => {
  switch (colorScheme) {
    case 'blue':
      return {
        bg: 'blue.90',
        color: 'blue.50',
      }

    case 'red':
      return {
        bg: 'red.90',
        color: 'red.50',
      }

    case 'purple':
    default:
      return {
        bg: 'purple.100',
        color: 'purple.50',
      }
  }
}

export const Tag = ({ colorScheme, ...props }) => {
  const colors = useMemo(() => getColors(colorScheme), [colorScheme])

  return (
    <Text
      as="span"
      bg={colors.bg}
      borderRadius="4px"
      color={colors.color}
      display="inline-block"
      fontSize="tiny"
      fontWeight="medium"
      px={1}
      py="0.125rem"
      {...props}
    />
  )
}
